export interface GetDeviceDataSchemeListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetDeviceDataSchemeListPagingAndFilterResponseData
}

export interface GetDeviceDataSchemeListPagingAndFilterResponseData {
    items: GetDeviceDataSchemeListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetDeviceDataSchemeListPagingAndFilterResponseItem {
    deviceDataSchemeId: string
    name: string
    deviceBrandId: string
    deviceBrandDetailId: string
    vehicleBrandId: string
    vehicleBrandDetailId: string
    modelYear: number
    deviceBrandName: string
    deviceBrandDetailName: string
    vehicleBrandName: string
    vehicleBrandDetailName: string
    deviceDataSchemeConnectionTypes: GetDeviceDataSchemeListPagingAndFilterResponseDeviceDataSchemeConnectionType[]
    deviceDataSchemeConnectionTypesStr: string
    deviceDataSchemeAccessories: GetDeviceDataSchemeListPagingAndFilterResponseDeviceDataSchemeAccessory[]
    deviceDataSchemeAccessoriesStr: string
    deviceDataSchemeDetails: any[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetDeviceDataSchemeListPagingAndFilterResponseDeviceDataSchemeConnectionType {
    deviceDataSchemeConnectionTypeId: string
    deviceDataSchemeId: string
    connectionTypeId: string
    connectionTypeName: string
    connectionTypeKey: string
}

export interface GetDeviceDataSchemeListPagingAndFilterResponseDeviceDataSchemeAccessory {
    deviceDataSchemeAccessoryId: string
    deviceDataSchemeId: string
    accessoryId: string
    accessoryName: string
    accessoryKey: string
}

export const initialGetDeviceDataSchemeListPagingAndFilterResponseData: GetDeviceDataSchemeListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}